import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { FeatureService } from '../../../../services/feature-service.service';
import { AnalyticsNotifierService } from '../../../../services/utils/analytics-notifier.service';
enum CancelReasonEnum {
    TooExpensive = 'Too expensive',
    DidNotMeetExpectations = 'Didn’t meet my expectations',
    TooDifficult = 'Too difficult to use',
    TechnicalIssues = 'Technical issues affected my experience',
    SwitchedTool = 'Switched to another tool',
    OneTimeProject = 'Needed it for a One-time project',
    Other = 'Other (Please specify)',
    NoRadioButtons = 'No radio buttons modal',
}
export interface ICancelSubscriptionResult {
    selectedOption: CancelReasonEnum | null;
    explanation: string | null;
}
export interface ICancelSubscriptionResultEvent extends ICancelSubscriptionResult {
    isRadioButtonsModal: boolean;
}
@Component({
    selector: 'app-cancel-subscription-modal',
    templateUrl: './cancel-subscription-modal.component.html',
    styleUrls: ['./cancel-subscription-modal.component.scss'],
})
export class CancelSubscriptionModalComponent implements OnInit {
    cancelForm: FormGroup;
    showRadioOptions: boolean = false;
    reasons: string[] = Object.values(CancelReasonEnum).filter((reason) => reason !== CancelReasonEnum.NoRadioButtons);
    constructor(
        private fb: FormBuilder,
        private dialogRef: MatDialogRef<CancelSubscriptionModalComponent>,
        private featureService: FeatureService,
        private analyticsNotifierService: AnalyticsNotifierService
    ) {
        this.cancelForm = this.fb.group({
            selectedReason: [''], // Used only if radio buttons are shown
            reason: ['', Validators.required],
        });
    }

    ngOnInit(): void {
        this.getSubscriptionCancelTypeAsync();
    }
    async getSubscriptionCancelTypeAsync() {
        this.showRadioOptions = await this.featureService.getFeatureAccessValue('cancellation_reason');
        const selectedReasonControl = this.cancelForm.get('selectedReason');
        const reasonControl = this.cancelForm.get('reason');

        if (this.showRadioOptions) {
            // Radio mode: only selectedReason is required
            selectedReasonControl?.setValidators([Validators.required]);

            // Make textarea optional always, even for "Other"
            reasonControl?.clearValidators();
        } else {
            // Textarea-only mode: textarea is required
            selectedReasonControl?.clearValidators();
            reasonControl?.setValidators([Validators.required]);
        }

        selectedReasonControl?.updateValueAndValidity();
        reasonControl?.updateValueAndValidity();
    }
    onCancelAnyway(): void {
        const selectedOption = this.cancelForm.get('selectedReason')?.value || null;
        const explanation = this.cancelForm.get('reason')?.value || null;

        const result: ICancelSubscriptionResult = this.showRadioOptions
            ? {
                  selectedOption,
                  explanation: selectedOption === CancelReasonEnum.Other ? explanation : null,
              }
            : {
                  selectedOption: null,
                  explanation,
              };
        const cancelSubscriptionResultEvent: ICancelSubscriptionResultEvent = {
            isRadioButtonsModal: this.showRadioOptions,
            selectedOption: selectedOption ?? CancelReasonEnum.NoRadioButtons,
            explanation: explanation ?? 'No explanation entered',
        };
        this.analyticsNotifierService.notifyEvent(`Cancellation reason list`, cancelSubscriptionResultEvent);
        this.dialogRef.close(result);
    }
    onKeepPlan(): void {
        this.dialogRef.close(null);
    }
    protected readonly CancelReasonEnum = CancelReasonEnum;
}
